<template>
  <span
    class="flex flex-row items-center justify-center gap-xs type-body-sm"
    v-if="props.isLoading"
    ><SmallSpinner color="white" /><span>Identifiering pågår...</span></span
  >
  <span
    v-else
    :class="{
      border: props.identified || props.manuallyIdentified,
      'rounded-2xl': true,
      'px-sm': true,
      'type-body-sm': true,
      'bg-amber-500': !props.identified && !props.manuallyIdentified,
      'text-text-primary': !props.identified && !props.manuallyIdentified,
    }"
    >{{ text }}</span
  >
</template>
<script setup lang="ts">
import { computed } from "vue";

import SmallSpinner from "@/components/ui/SmallSpinner.vue";

const props = defineProps<{
  isLoading: boolean;
  identified: boolean;
  manuallyIdentified: boolean;
}>();

const text = computed(() => {
  const manuallyVerifiedText = props.manuallyIdentified
    ? "Manuellt identifierad"
    : "Inte identifierad";

  return props.identified ? "Identifierad" : manuallyVerifiedText;
});
</script>
